<ng-container *ngIf="loaded">
  <div class="section" *ngIf="futureGames.length > 0 || closedGames.length > 0">
    <div class="slider-item" *ngIf="futureGames.length > 0">
      <div class="title">Грядущие игры <span class="count">{{ futureGames.length }}</span></div>

      <mtg-data-slider>
        <mtg-data-slider-item *ngFor="let game of futureGames">
          <a [routerLink]="getGameRoute(game.id)">
            <mtg-game-card
              [game]="game"
            ></mtg-game-card>
          </a>
        </mtg-data-slider-item>
      </mtg-data-slider>
    </div>
    <div class="slider-item" *ngIf="closedGames.length > 0">
      <div class="title">Сыгранные игры <span class="count">{{ closedGames.length }}</span></div>

      <mtg-data-slider>
        <mtg-data-slider-item *ngFor="let game of closedGames; trackBy: trackById">
          <a [routerLink]="getGameRoute(game.id)">
            <mtg-game-card
              [game]="game"
            ></mtg-game-card>
          </a>
        </mtg-data-slider-item>
      </mtg-data-slider>
    </div>
  </div>
</ng-container>
<mtg-spinner *ngIf="!loaded"></mtg-spinner>
